import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  balanceBillingClaimStatus: {
    step: number;
    subSteps: {
      id: number;
      subStep: string;
      tip: string[];
      progress: string;
    }[];
  };
  error: boolean;
  loading: boolean;
} = {
  balanceBillingClaimStatus: {
    step: 0,
    subSteps: [
      {
        id: 0,
        subStep: "",
        tip: [],
        progress: "",
      },
    ],
  },
  error: false,
  loading: false,
};
const fetchBalanceBillingClaimStatus = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BALANCE_BILLING_CLAIM_STATUS_SUCCESS: {
      return updateObject(state, {
        balanceBillingClaimStatus: action.balanceBillingClaimStatus,
        error: false,
        loading: false,
      });
    }
    case actionTypes.FETCH_BALANCE_BILLING_CLAIM_STATUS_STARTED:
      return updateObject(state, {
        balanceBillingClaimStatus: initialState.balanceBillingClaimStatus,
        error: false,
        loading: true,
      });

    case actionTypes.FETCH_BALANCE_BILLING_CLAIM_STATUS_FAILED:
      return updateObject(state, {
        balanceBillingClaimStatus: initialState.balanceBillingClaimStatus,
        error: true,
        loading: false,
      });

    default:
      return state;
  }
};

export default fetchBalanceBillingClaimStatus;
